import { render, staticRenderFns } from "./ConfigurationForm115.vue?vue&type=template&id=096d6019&scoped=true&lang=pug&"
import script from "./ConfigurationForm115.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationForm115.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurationForm115.vue?vue&type=style&index=0&id=096d6019&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096d6019",
  null
  
)

export default component.exports